import { render, staticRenderFns } from "./ItemAIImportInterface.vue?vue&type=template&id=04c66223"
import script from "./ItemAIImportInterface.vue?vue&type=script&lang=js"
export * from "./ItemAIImportInterface.vue?vue&type=script&lang=js"
import style0 from "./ItemAIImportInterface.vue?vue&type=style&index=0&id=04c66223&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtnToggle,VSelect,VTextField})
